import { Message } from 'rsuite'

// Save a new report - this will be implemented by the backend later
export const saveNewScenarioReport = async (reportData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/scenarios/reports`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-type': 'application/json',
        },
        body: JSON.stringify(reportData),
      },
    )

    if (response.ok) {
      const responseData = await response.json()
      return { success: true, data: responseData.data }
    } else {
      throw new Error('Failed to save report.')
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      error: error.message || 'Failed to save new report',
    }
  }
}

// Update an existing report - this will be implemented by the backend later
export const updateScenarioReport = async (reportId, reportData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/scenarios/reports/${reportId}`,
      {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-type': 'application/json',
        },
        body: JSON.stringify(reportData),
      },
    )

    if (response.ok) {
      const responseData = await response.json()
      return { success: true, data: responseData.data }
    } else {
      throw new Error('Failed to save report.')
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      error: error.message || 'Failed to save new report',
    }
  }
}

// Delete an existing report - this will be implemented by the backend later
export const deleteScenarioReport = async (reportId, pushToast) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/scenarios/reports/${reportId}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      },
    )

    if (response.ok) {
      pushToast(
        <Message type="success">Report deleted successfully.</Message>,
        { placement: 'topCenter', duration: 5000 },
      )
      return true
    } else {
      throw new Error('Failed to delete report.')
    }
  } catch (error) {
    console.error(error)
    pushToast(
      <Message type="error">
        {error.message || 'Failed to delete report'}
      </Message>,
      { placement: 'topCenter', duration: 5000 },
    )
    return false
  }
}
